import { put, takeLatest } from "redux-saga/effects";
import { getJwt } from "../../../crud/auth.crud";
import { postRequestWrapper } from "../../../utils/fetch";
import { normalizeAndValidateAsin } from '../../../utils/asins';
import { notify } from 'app/Services/app/notificationService/notify';
import { actions as authActions } from "../auth/actions";
import { actions } from './actions';
import { actionTypes } from './actionTypes';

export function* watchMultipleAsinsAnalysisSaga() {
    yield takeLatest(actionTypes.FetchMultipleAsinsAnalysis, apiFetchMultipleAsinsAnalysisSaga);
    yield takeLatest(actionTypes.FetchSuggestedKeywords, apiFetchSuggestedKeywordsSaga);
}

function* apiFetchMultipleAsinsAnalysisSaga(action) {
    yield put(authActions.disableSendButtonState());
    yield put(actions.clearResultsAnalysis());
    const token = yield getJwt();
    const validatedAsins = [];
    for (const asin of action.payload.ASINs) {
      const { asin: normalized, valid } = normalizeAndValidateAsin(asin);
      if (!valid) {
        notify.error(`Invalid ASIN: ${asin}. Skipping.`);
        continue;
      }
      validatedAsins.push(normalized);
    }
    if (validatedAsins.length === 0) {
      notify.error('No valid ASINs provided.');
      yield put(authActions.disableSendButtonState(false));
      return;
    }
    const requestPayload = {
      ASINs: validatedAsins,
      limit: action.payload.limit,
      marketplace: action.payload.marketplace,
    };
    const apiRes = yield postRequestWrapper("/multiple-asins-analysis", token, requestPayload);
    if (apiRes) {
      yield put(actions.updateMultipleAsinsAnalysis(apiRes));
    }
    yield put(authActions.disableSendButtonState(false));
}

function* apiFetchSuggestedKeywordsSaga(action) {
    yield put(authActions.disableSendButtonState());
    const token = yield getJwt();
    const { asin, valid } = normalizeAndValidateAsin(action.payload.ASIN);
    if (!valid) {
      notify.error('Invalid ASIN. Please enter a 10-character alphanumeric ASIN.');
      yield put(authActions.disableSendButtonState(false));
      return;
    }
    const requestPayload = {
      ASIN: asin,
    };
    const apiRes = yield postRequestWrapper("/suggested-keywords", token, requestPayload);
    if (apiRes) {
      yield put(actions.updateSuggestedKeywords(apiRes));
    }
    yield put(authActions.disableSendButtonState(false));
}